import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Organizations from './pages/Organizations';
import IntroToAIUsers from './pages/IntroToAIUsers';
import IntroToAIOrganizations from './pages/IntroToAIOrganizations';
import GenAIUsers from './pages/GenAIUsers';
import Projects from './pages/Projects';

const theme = createTheme({
  palette: {
    primary: {
      main: '#6355FF',
    },
    secondary: {
      main: '#9333E9',
    },
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/uaup/organizations"
              element={
                <ProtectedRoute>
                  <Organizations />
                </ProtectedRoute>
              }
            />
            <Route
              path="/uaup/users"
              element={
                <ProtectedRoute>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/uaup/projects"
              element={
                <ProtectedRoute>
                  <Projects />
                </ProtectedRoute>
              }
            />
            <Route
              path="/intro-to-ai/organizations"
              element={
                <ProtectedRoute>
                  <IntroToAIOrganizations />
                </ProtectedRoute>
              }
            />
            <Route
              path="/intro-to-ai/users"
              element={
                <ProtectedRoute>
                  <IntroToAIUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/genai/users"
              element={
                <ProtectedRoute>
                  <GenAIUsers />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
